// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Modal_overlay__Mmhcm {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  z-index: 1000;
  animation: Modal_modal-fade__sl3Ou 0.15s ease;
}

@keyframes Modal_modal-fade__sl3Ou {
  from { opacity: 0; }
  to { opacity: 1; }
}

.Modal_panel__eJCg9 {
  width: 100%;
  max-width: 560px;
  max-height: 88vh;
  display: flex;
  flex-direction: column;
  background: var(--dylo-surface);
  border: 1.5px solid var(--dylo-surface-border);
  border-radius: 18px;
  box-shadow: 0 30px 80px rgba(0, 0, 0, 0.4);
  overflow: hidden;
  animation: Modal_dylo-pop__OtkpT 0.18s ease both;
}

.Modal_header__l\\+p\\+i {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 18px 22px;
  border-bottom: 1px solid var(--dylo-line);
}
.Modal_title__7bDhh {
  font-size: 17px;
  font-weight: 700;
  color: var(--dylo-ink);
  margin: 0;
}
.Modal_close__ll7Hz {
  border: none;
  background: transparent;
  color: var(--dylo-muted);
  cursor: pointer;
  display: inline-flex;
  padding: 4px;
  border-radius: 6px;
}
.Modal_close__ll7Hz:hover {
  color: var(--dylo-ink);
  background: color-mix(in srgb, var(--dylo-muted) 12%, transparent);
}

.Modal_body__S7-sN {
  padding: 20px 22px;
  /* El modal se renderiza por portal fuera del root V2; sin color explícito el
     texto plano hereda negro y se pierde en dark mode. Fija el color del tema. */
  color: var(--dylo-ink);
  overflow-y: auto;
  overflow-x: hidden;
  scrollbar-width: thin;
  scrollbar-color: color-mix(in srgb, var(--dylo-muted) 35%, transparent) transparent;
}
.Modal_body__S7-sN::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}
.Modal_body__S7-sN::-webkit-scrollbar-track {
  background: transparent;
}
.Modal_body__S7-sN::-webkit-scrollbar-thumb {
  background: color-mix(in srgb, var(--dylo-muted) 35%, transparent);
  border-radius: 3px;
}
.Modal_body__S7-sN::-webkit-scrollbar-thumb:hover {
  background: color-mix(in srgb, var(--dylo-muted) 55%, transparent);
}

.Modal_footer__CcyES {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  padding: 16px 22px;
  border-top: 1px solid var(--dylo-line);
}
`, "",{"version":3,"sources":["webpack://./src/v2/components/ui/Modal/Modal.module.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,QAAQ;EACR,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,aAAa;EACb,6CAAgC;AAClC;;AAEA;EACE,OAAO,UAAU,EAAE;EACnB,KAAK,UAAU,EAAE;AACnB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,+BAA+B;EAC/B,8CAA8C;EAC9C,mBAAmB;EACnB,0CAA0C;EAC1C,gBAAgB;EAChB,gDAAmC;AACrC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,yCAAyC;AAC3C;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,YAAY;EACZ,uBAAuB;EACvB,wBAAwB;EACxB,eAAe;EACf,oBAAoB;EACpB,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,sBAAsB;EACtB,kEAAkE;AACpE;;AAEA;EACE,kBAAkB;EAClB;iFAC+E;EAC/E,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;EACrB,mFAAmF;AACrF;AACA;EACE,UAAU;EACV,WAAW;AACb;AACA;EACE,uBAAuB;AACzB;AACA;EACE,kEAAkE;EAClE,kBAAkB;AACpB;AACA;EACE,kEAAkE;AACpE;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,kBAAkB;EAClB,sCAAsC;AACxC","sourcesContent":[".overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.45);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 24px;\n  z-index: 1000;\n  animation: modal-fade 0.15s ease;\n}\n\n@keyframes modal-fade {\n  from { opacity: 0; }\n  to { opacity: 1; }\n}\n\n.panel {\n  width: 100%;\n  max-width: 560px;\n  max-height: 88vh;\n  display: flex;\n  flex-direction: column;\n  background: var(--dylo-surface);\n  border: 1.5px solid var(--dylo-surface-border);\n  border-radius: 18px;\n  box-shadow: 0 30px 80px rgba(0, 0, 0, 0.4);\n  overflow: hidden;\n  animation: dylo-pop 0.18s ease both;\n}\n\n.header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 18px 22px;\n  border-bottom: 1px solid var(--dylo-line);\n}\n.title {\n  font-size: 17px;\n  font-weight: 700;\n  color: var(--dylo-ink);\n  margin: 0;\n}\n.close {\n  border: none;\n  background: transparent;\n  color: var(--dylo-muted);\n  cursor: pointer;\n  display: inline-flex;\n  padding: 4px;\n  border-radius: 6px;\n}\n.close:hover {\n  color: var(--dylo-ink);\n  background: color-mix(in srgb, var(--dylo-muted) 12%, transparent);\n}\n\n.body {\n  padding: 20px 22px;\n  /* El modal se renderiza por portal fuera del root V2; sin color explícito el\n     texto plano hereda negro y se pierde en dark mode. Fija el color del tema. */\n  color: var(--dylo-ink);\n  overflow-y: auto;\n  overflow-x: hidden;\n  scrollbar-width: thin;\n  scrollbar-color: color-mix(in srgb, var(--dylo-muted) 35%, transparent) transparent;\n}\n.body::-webkit-scrollbar {\n  width: 6px;\n  height: 6px;\n}\n.body::-webkit-scrollbar-track {\n  background: transparent;\n}\n.body::-webkit-scrollbar-thumb {\n  background: color-mix(in srgb, var(--dylo-muted) 35%, transparent);\n  border-radius: 3px;\n}\n.body::-webkit-scrollbar-thumb:hover {\n  background: color-mix(in srgb, var(--dylo-muted) 55%, transparent);\n}\n\n.footer {\n  display: flex;\n  justify-content: flex-end;\n  gap: 10px;\n  padding: 16px 22px;\n  border-top: 1px solid var(--dylo-line);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"overlay": `Modal_overlay__Mmhcm`,
	"modal-fade": `Modal_modal-fade__sl3Ou`,
	"panel": `Modal_panel__eJCg9`,
	"dylo-pop": `Modal_dylo-pop__OtkpT`,
	"header": `Modal_header__l+p+i`,
	"title": `Modal_title__7bDhh`,
	"close": `Modal_close__ll7Hz`,
	"body": `Modal_body__S7-sN`,
	"footer": `Modal_footer__CcyES`
};
export default ___CSS_LOADER_EXPORT___;
